function displayMessage(countryCode) {
  var notificationMessage = document.getElementById("notificationMessage");

  switch (countryCode) {
    case "GB":
      notificationMessage.innerHTML =
        "<p>Exchange and returns inside the UK.</p>";
      break;
    case "DE":
    case "BE":
    case "AT":
    case "NL":
    case "FR":
      notificationMessage.innerHTML =
        "<p>We ship from Dusseldorf, Germany.</p>";
      break;
    case "PT":
      notificationMessage.innerHTML = "<p>We ship from Lisbon, Portugal.</p>";
    default:
     notificationMessage.innerHTML = "<p>We ship from Lisbon, Portugal.</p>";
  }
}

function getCountry() {
  fetch("https://ipinfo.io/json?token=e2a15afb5ecbd1")
    .then((response) => response.json())
    .then((data) => {
      var countryCode = data.country;
      console.log("Código do País:", countryCode);

      // Validate the country code here
      var allowedCountries = ["GB", "DE", "PT", "BE", "AT", "NL", "FR"];
      if (allowedCountries.includes(countryCode)) {
        displayMessage(countryCode);
      } else {
        displayMessage(countryCode);
      }
    })
    .catch((error) => {
      console.error("Erro na solicitação:", error);
    });
}

getCountry();
